import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';

export interface ConfirmData {
  title?: string;
  content?: string;
  cancelButtonText?: string;
  okButtonText?: string;
  color?: 'primary' | 'error';
}

@Component({
  selector: 'app-confirm',
  standalone: true,
  imports: [CommonModule, Button, TranslocoPipe],
  template: `
    <div class="relative max-w-[500px] px-6 pb-6 pt-8 xl:max-w-[600px] xl:px-10 xl:pt-12">
      <h2 class="m-0 text-xl font-semibold">{{ data?.title | transloco }}</h2>
      <div class="mt-4" [innerHTML]="data?.content | transloco: { lineBreak: '<br /><br />' }"></div>
      <div class="mt-8 flex w-full items-center justify-end gap-2 overflow-hidden xl:mt-12">
        <p-button
          [label]="data?.cancelButtonText | transloco"
          severity="secondary"
          class="max-w-1/2 overflow-hidden"
          styleClass="!truncate !block !max-w-full !whitespace-nowrap"
          (click)="onCloseClick()"
          data-testid="confirm-cancel-button"></p-button>
        <p-button
          [label]="data?.okButtonText | transloco"
          [severity]="data?.color === 'error' ? 'danger' : 'primary'"
          class="max-w-1/2 overflow-hidden"
          styleClass="!truncate !block !max-w-full !whitespace-nowrap"
          (click)="onOkClick()"
          data-testid="confirm-ok-button"></p-button>
      </div>
    </div>
  `,
})
export class ConfirmComponent {
  @Input() data: ConfirmData | undefined;
  @Input() close: (() => void) | undefined;
  @Input() okClicked: (() => void) | undefined;

  onCloseClick() {
    this.close?.();
  }

  onOkClick() {
    this.okClicked?.();
  }
}
